<div class="spinner-wrapper">
    <app-loading></app-loading>
    <h4 *ngIf="message">{{message}}</h4>
</div>
